export const ORDER_AT_DATE_FORMAT = 'MMMM Do, YYYY h:mma';
export const EXTERNAL_DATE_FORMAT = 'YYYY-MM-DDThh:mm';
export const NO_ORDERS_MESSAGE_TITLE = 'Sorry, we could not find any orders';
export const NO_ORDERS_MESSAGE_DESCRIPTION =
  "You either don't have any orders or you need to adjust the filters";
export const ERROR_FETCHING_ORDERS_MESSAGE_TITLE = 'Sorry, we had an issue getting your orders';
